import {Component} from '@angular/core';

import {UIDialogService} from 'app/ui/dialog/dialog.service';

@Component({
    selector: 'contact-us',
    templateUrl: 'contact-us.component.html',
    styleUrls: ['contact-us.component.scss']
})
export class ContactUsComponent {
    constructor(private _dialogService: UIDialogService) {
    }

    close() {
        this._dialogService.close();
    }
}